import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { AccessLevel } from 'models/AccessLevel';
import type { Box } from 'models/Box';

// How a box is named on screen, in the page language. A box can be saved
// without a name, so it falls back to "My Memory Box".
export const useBoxLabels = () => {
  const t = useTranslations();

  // The same functions on every render, so they can be effect and memo
  // dependencies.
  return useMemo(
    () => ({
      boxName: (name?: string | null): string => name || t('boxes.untitled'),
      accessLevel: (box: Pick<Box, 'accessLevel'>): string =>
        box.accessLevel === AccessLevel.Shared
          ? t('boxes.accessLevel.shared')
          : t('boxes.accessLevel.private'),
    }),
    [t],
  );
};
